// lib/organisation-teams/legacy-teams-2d-access.ts

const LEGACY_TEAMS_2D_USER_IDS = new Set([
  '665f5c236de32fb66dad6c81',
  '680f5aefb1c5d15b63103e4e',
]);

export const isLegacyTeams2DUser = (dbUserId: string | null | undefined): boolean =>
  typeof dbUserId === 'string' && LEGACY_TEAMS_2D_USER_IDS.has(dbUserId);
